import { render, staticRenderFns } from "./caseCustomFields.vue?vue&type=template&id=23ffd548&"
import script from "./caseCustomFields.vue?vue&type=script&lang=js&"
export * from "./caseCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports